import {dataAPI} from "services/Api/apiConsumer";

export const requestValueReview = async (data: any) => {
  return await dataAPI.post(`/email/review`, data);
};
